$(document).ready(function () {
  let glide = new Glide('.yumtein__blog-featured .glide', {
    type: 'slider',
    perView: 1,
    gap: 0,
    dots: true,
  });

  glide.on('build.after', function() {
    var slideHeight = $('.glide__slide--active').outerHeight();
    var glideTrack = $('.glide__track').outerHeight();
    if (slideHeight != glideTrack) {
      var newHeight = slideHeight;
      $('.glide__track').css('height', newHeight);
    }
  });

  glide.on('run.after', function() {
    var slideHeight = $('.glide__slide--active').outerHeight();
    var glideTrack = $('.glide__track').outerHeight();
    if (slideHeight != glideTrack) {
      var newHeight = slideHeight;
      $('.glide__track').css('height', newHeight);
    }
  });

  glide.mount();

  $(window).on('load', function() {
    setTimeout(() => {
      glide.mount();
    }, 200);
  });
});

$(document).on('click', '#load-more-article', function () {
  const filteredHiddenArticles = $('.yumtein__blog-main-articles-inner-item.article.filtered:hidden');
  const allHiddenArticles = $('.yumtein__blog-main-articles-inner-item.article:hidden');

  if (filteredHiddenArticles.length > 0) {
    filteredHiddenArticles.slice(0, 12).show(200);
  } else {
    allHiddenArticles.slice(0, 12).show(200);
  }

  const filteredVisibleArticle = $('.yumtein__blog-main-articles-inner-item.article.filtered:visible').length;
  const filteredTotalArticle = $('.yumtein__blog-main-articles-inner-item.article.filtered').length;

  const visibleArticle = $('.yumtein__blog-main-articles-inner-item.article:visible').length;
  const totalArticle = $('.yumtein__blog-main-articles-inner-item.article').length;

  if (filteredTotalArticle > 0) {
    $('#show__count').text(filteredVisibleArticle);
    $('#all__count').text(filteredTotalArticle);
  } else {
    $('#show__count').text(visibleArticle);
    $('#all__count').text(totalArticle);
  }

  if ($('#show__count').text() == $('#all__count').text()) {
    $('#load-more-article').hide();
  }
});

$(document).ready(function () {
  var allPosts = $('.yumtein__blog-main-articles-inner-item');
  var resultsCount = $('#results_count');

  const urlParams = new URLSearchParams(window.location.search);
  const categoryParam = urlParams.get('category');

  if (categoryParam) {
    $('.yumtein__blog-main-filter-fb-item button').each(function () {
      const buttonCategory = $(this).attr('data-category');
      if (buttonCategory && buttonCategory.toLowerCase() === categoryParam.toLowerCase()) {
        $('.yumtein__blog-main-filter-fb-item button').removeClass('active');
        $(this).addClass('active');
        return false;
      }
    });
  }

  $('#blog_filter').on('input', function () {
    filterPosts();
  });

  $('.yumtein__blog-main-filter-fb-item button').on('click', function () {
    $('.yumtein__blog-main-filter-fb-item button').removeClass('active');
    $(this).addClass('active');
    filterPosts();
  });

  if (categoryParam) {
    filterPosts();
  }

  $(document).on('click', '.category-button', function () {
    const inlineCategory = $(this).attr('data-category');
    $('#blog_filter').val('');

    $('.yumtein__blog-main-filter-fb-item button').each(function () {
      const buttonCategory = $(this).attr('data-category');
      if (buttonCategory && buttonCategory.toLowerCase() === inlineCategory.toLowerCase()) {
        $('.yumtein__blog-main-filter-fb-item button').removeClass('active');
        $(this).addClass('active');
        return false;
      }
    });

    filterPosts();
  });

  $(document).on('change', '#blog_category_filter', function () {
    filterPosts();
  });

  function showButton() {
    const visibleArticle = $('.yumtein__blog-main-articles-inner-item.article:visible').length;
    const allArticles = $('.yumtein__blog-main-articles-inner-item.article.filtered').length;
    $('#show__count').text(visibleArticle);
    $('#all__count').text(allArticles);
    if ($('#show__count').text() == $('#all__count').text()) {
      $('#load-more-article').hide();
    } else {
      $('#load-more-article').show();
    }
  }

  function filterPosts() {
    showLoading();

    setTimeout(function () {
      var searchTerm = $('#blog_filter').val().toLowerCase();
      var selectedCategory = $('#blog_category_filter').val().toLowerCase();
      var filteredPosts = [];

      allPosts.each(function () {
        var post = $(this);
        var title = post.find('.yumtein__blog-main-articles-inner-item-title a').text().toLowerCase();
        var imgAlt = post.find('.yumtein__blog-main-articles-inner-item-img img').attr('alt').toLowerCase();
        var categories = post
          .find('.yumtein__blog-main-articles-inner-item-categories button')
          .map(function () {
            return $(this).attr('data-category').toLowerCase();
          })
          .get();

        var matchesSearch = title.includes(searchTerm) || imgAlt.includes(searchTerm);
        var matchesCategory = selectedCategory === 'all_articles' || categories.includes(selectedCategory);

        if (matchesSearch && matchesCategory) {
          filteredPosts.push(post);
          post.addClass('filtered');
        } else {
          post.hide();
          post.removeClass('filtered');
        }
      });

      if (filteredPosts.length > 0) {
        $('.yumtein__blog-main-articles-inner-ic').hide();
        filteredPosts.forEach(function (post, index) {
          if (index < 12) {
            post.show();
          } else {
            post.hide();
          }
        });

        showButton();
      } else {
        $('.yumtein__blog-main-articles-inner-ic').hide();
        resultsCount.text('No results matched your search.');
      }

      if (selectedCategory === 'all_articles' && searchTerm === '') {
        $('.yumtein__blog-main-articles-inner-ic').show();
        allPosts.slice(0, 12).show();
        showButton();
      }

      hideLoading();
    }, 1000);
  }

  function showLoading() {
    $('.yumtein__blog-main-articles').addClass('loading');
    $('.yumtein__blog-main-articles').append('<div class="loading"><span></span></div>');
  }

  function hideLoading() {
    $('.yumtein__blog-main-articles').removeClass('loading');
    $('.yumtein__blog-main-articles .loading').remove();
  }
});
